import { Grid } from "@material-ui/core"
import TarjetaCliente from "./TarjetaCliente"
import TapCliente from "./../TapCliente"
const ClienteViaje = () => {
    return (
        <Grid container>
            <Grid item xs={3}>
                <TarjetaCliente />
            </Grid>
            <Grid item xs={9}>
                <TapCliente />
            </Grid>
        </Grid>
    )
}
export default ClienteViaje